import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@mui/material';

import { selectMyMeals } from '@app/modules/my-meals/selectors';
import { setMyMeals } from '@app/modules/my-meals/slice';
import { SvgColor } from './svg-color';

type Props = {
  item: any;
  style: any;
};

const IsMyMealIcon = ({ item, style }: Props) => {
  const dispatch = useDispatch();

  const myMeals = useSelector(selectMyMeals);

  const isMyMeal = myMeals?.find((i) => i.uri === item.uri)
    ? `/assets/icons/ic_filled_hat.svg`
    : `/assets/icons/ic_red_hat.svg`;

  return (
    <IconButton
      onMouseDown={(event) => event.stopPropagation()}
      onClick={() => dispatch(setMyMeals(item))}
      style={style}
    >
      <SvgColor src={isMyMeal} sx={styles.shareImage} />
    </IconButton>
  );
};

export const styles = {
  shareImage: { height: 40, width: 30, m: -0.25 },
};

export { IsMyMealIcon };
